import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from 'store/actions/blocks.action'
import { IEvaluationBlockModel } from 'models/block.model'
import { createEvaluationInstance } from 'api/administration/blocks/Create'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'

async function handleEvaluationSurveyBlock(data: IEvaluationBlockModel) {
  return await createEvaluationInstance(data)
}

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}

function* newEvaluationBlockEffectSaga(action: any) {
  try {
    const { data } = action
    const result = yield call(handleEvaluationSurveyBlock, data)
    yield put(fromActions.Actions.createBlockInstanceSuccess(result))
    const {
      block_instance: { lesson_id },
    } = data
    const blocks = yield call(getList, lesson_id)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(blocks))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* createEvaluationWatcherSaga() {
  yield takeLatest(
    fromActions.EVALUATION_BLOCK_CREATE,
    newEvaluationBlockEffectSaga
  )
}
